//BRAND
export const name = process.env.REACT_APP_COMPANY_NAME || 'Coursolo.ai';
export const company = 'Coursolo';

// Environment detection
const isProduction = process.env.NODE_ENV === 'production';
const rawKnowledgeFlag = process.env.ENABLE_KNOWLEDGE_SHARING ?? process.env.REACT_APP_ENABLE_KNOWLEDGE_SHARING;
export const knowledgeSharingEnabled = String(rawKnowledgeFlag ?? 'true').toLowerCase() !== 'false';

// Server URL configuration
export const websiteURL = process.env.REACT_APP_WEBSITE_URL || 
  (isProduction ? 'https://coursolo.ai' : 'http://localhost:3000');

function resolveServerURL() {
  const fromEnv = (process.env.REACT_APP_SERVER_URL || '').trim();
  const fallback = isProduction ? 'https://api.coursolo.ai' : 'http://localhost:8000';
  let url = fromEnv || fallback;

  // Runtime guard: a production hostname must never use a localhost API
  // (mis-set REACT_APP_SERVER_URL causes mixed-content + broken images).
  if (typeof window !== 'undefined') {
    const pageHost = window.location.hostname || '';
    const pageIsLocal = pageHost === 'localhost' || pageHost === '127.0.0.1';
    if (!pageIsLocal) {
      try {
        const apiHost = new URL(url).hostname;
        if (apiHost === 'localhost' || apiHost === '127.0.0.1') {
          url = 'https://api.coursolo.ai';
        }
      } catch {
        url = 'https://api.coursolo.ai';
      }
    }
  }

  return url.replace(/\/$/, '');
}

export const serverURL = resolveServerURL();

export const logo = process.env.REACT_APP_COMPANY_LOGO || 'https://firebasestorage.googleapis.com/v0/b/coursolo.firebasestorage.app/o/logo512.png?alt=media&token=8c391280-f261-44e9-9c50-5ed0b6bc2247';

export const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL || 'support@coursolo.ai';
export const contactEmail = process.env.REACT_APP_CONTACT_EMAIL || 'contact@coursolo.ai';
export const helloEmail = process.env.REACT_APP_HELLO_EMAIL || 'hello@coursolo.ai';

export const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER || '31684038024';
export const whatsappDisplay = process.env.REACT_APP_WHATSAPP_DISPLAY || '+31 684038024';

export const companyLegal = {
  name: process.env.REACT_APP_COMPANY_LEGAL_NAME || 'Abbaly Media Agency',
  brand: company,
  address: process.env.REACT_APP_COMPANY_ADDRESS || 'Netherlands',
  siret: process.env.REACT_APP_COMPANY_SIRET || '',
  vat: process.env.REACT_APP_COMPANY_VAT || '',
  hosting: process.env.REACT_APP_HOSTING_PROVIDER || 'Cloud infrastructure (EU)',
  dpoEmail: process.env.REACT_APP_DPO_EMAIL || 'privacy@coursolo.ai',
};

export const socialURLs = {
  twitter: process.env.REACT_APP_TWITTER_URL || 'https://x.com/coursolo',
  linkedin: process.env.REACT_APP_LINKEDIN_URL || 'https://www.linkedin.com/company/coursolo-ai/',
  facebook: process.env.REACT_APP_FACEBOOK_URL || 'https://www.facebook.com/61588194894070',
  github: process.env.REACT_APP_GITHUB_URL || 'https://github.com/coursolo',
};

/** Product demo video (landing hero, features page, guest home). */
export const DEMO_VIDEO_ID = 'efrQ_58-OtM';
export const DEMO_VIDEO_URL = `https://youtu.be/${DEMO_VIDEO_ID}`;
export const razorpayEnabled = false;
export const paypalEnabled = false;
export const stripeEnabled = process.env.REACT_APP_STRIPE_ENABLED === 'true' || true;
export const paystackEnabled = false;
export const flutterwaveEnabled = false;

//PRICING :-

//FREE 
export const FreeType = 'Free Plan';
export const FreeCost = '0';
export const FreeTime = 'month';

//MONTHLY 
export const MonthType = 'Monthly Plan';
export const MonthCost = '19';
export const MonthTime = 'month';

//YEARLY 
export const YearType = 'Yearly Plan';
export const YearCost = '190';  // €19 * 10 months (12 months - 2 months free, Save €38)
export const YearTime = 'year';

// Subscription Features
export const FreeFeatures = [
    '5 Text & Image courses',
    '2 Video courses',
    '5 sub-topics per course',
    'Basic course creation',
    'Standard support'
];

export const MonthFeatures = [
    'Unlimited Text & Image courses',
    'Unlimited Video courses',
    '10 sub-topics per course',
    'AI Storyteller access',
    'Priority support',
    'Advanced analytics',
    'Custom branding'
];

export const YearFeatures = [
    'Unlimited Text & Image courses',
    'Unlimited Video courses',
    '10 sub-topics per course',
    'AI Storyteller access',
    'Priority support',
    'Advanced analytics',
    'Custom branding',
    '3 months free'
];

//TESTIMONIAL
export const review = "The AI Course Generator revolutionized my content creation process, providing accurate and relevant topics effortlessly. It's a time-saving powerhouse that enhances the quality and relevance of my courses. A must-have tool for educators seeking efficiency and impactful online learning experiences.";
export const from = "Anam Meena Sharif";
export const profession = 'CFO at Spacester';
export const photoURL = 'https://play-lh.googleusercontent.com/sV_ffBmBJt_je4RZHnfaCfcnL-Hy6C14Iol7H5EMj9fzI2GDOonuojdn5t9p6n9IAX8j';

//PAYPAL
export const paypalPlanIdOne = process.env.REACT_APP_PAYPAL_PLAN_ONE;
export const paypalPlanIdTwo = process.env.REACT_APP_PAYPAL_PLAN_TWO;

//RAZORPAY
export const razorpayKeyId = process.env.REACT_APP_RAZORPAY_KEY_ID;
export const razorpayPlanIdOne = process.env.REACT_APP_RAZORPAY_PLAN_ONE;
export const razorpayPlanIdTwo = process.env.REACT_APP_RAZORPAY_PLAN_TWO;

//STRIPE
export const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
export const stripePlanIdOne = process.env.REACT_APP_STRIPE_PLAN_ONE || 'price_1RVvYWPOr7e1CUGsXBHtXCnl';
export const stripePlanIdTwo = process.env.REACT_APP_STRIPE_PLAN_TWO || 'price_1RVvaKPOr7e1CUGsjVv6hjKm';

//PAYSTACK
export const paystackPlanIdOne = process.env.REACT_APP_PAYSTACK_PLAN_ONE;
export const paystackPlanIdTwo = process.env.REACT_APP_PAYSTACK_PLAN_TWO;
export const amountInZarOne = '170';
export const amountInZarTwo = '1871';

//FLUTTERWAVE
export const flutterwavePlanIdOne = process.env.REACT_APP_FLUTTERWAVE_PLAN_ONE;
export const flutterwavePlanIdTwo = process.env.REACT_APP_FLUTTERWAVE_PLAN_TWO;
export const flutterwavePublicKey = process.env.REACT_APP_FLUTTERWAVE_PUBLIC_KEY;

// Helper function to get Stripe plan ID based on plan type
export const getStripePlanId = (planType) => {
    switch(planType) {
        case MonthType:
        case 'Plan Mensuel':
            return stripePlanIdOne;
        case YearType:
        case 'Plan Annuel':
            return stripePlanIdTwo;
        default:
            return null;
    }
};